import { Suspense } from 'react';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import ContactMap from './components/ContactMap';
import ContactHelpWith from './components/ContactHelpWith';
import ContactWhyUs from './components/ContactWhyUs';
import ContactFaq from './components/ContactFaq';
import WashingtonBuyerFaq from './components/WashingtonBuyerFaq';
import Breadcrumb from '../../components/feature/Breadcrumb';
import { useSEOHead } from '../../hooks/useSEOHead';

const BASE = 'https://rockhoundauto.com';

export default function ContactPage() {
  useSEOHead({
    title: 'Contact Rockhound Auto | Warrenton OR Near Astoria',
    description: 'Contact Rockhound Auto — Warrenton Oregon\'s no-fee used car dealer. Call, text, or visit us near Astoria, Seaside & the Oregon Coast. Fast replies, zero pressure.',
    keywords: 'contact used car dealer Warrenton OR, Rockhound Auto phone number, used car dealer near Astoria Oregon, Oregon Coast car dealer contact, used cars Warrenton Oregon',
    canonicalUrl: `${BASE}/contact`,
    geoRegion: 'US-OR',
    geoPlacename: 'Warrenton, Oregon',
    geoPosition: '46.1651;-123.9237',
  });

  // Schema injection is handled entirely by SchemaManager for /contact:
  //   schema-manager-webpage  → ContactPage
  //   schema-manager-localbusiness → AutoDealer / LocalBusiness (full detail)
  //   schema-manager-breadcrumb    → BreadcrumbList
  //   schema-manager-page-faq      → FAQPage (pageFaqs.contact)
  // No local useEffect needed — prevents triple duplicate schema warnings.

  return (
    <>
      <Breadcrumb items={[{ label: 'Contact' }]} />

      <ContactHero
        theme="light"
        eyebrow={{ icon: 'ri-message-3-line', text: 'We Reply Fast' }}
        title="Let's Talk"
        titleAccent="About Your Next Car"
        subtitle="Call, text, email, or stop by. We're here to answer questions, schedule test drives, and help you find the right car — no pressure."
      />

      <ContactInfo />
      <ContactHelpWith />
      <ContactForm />
      <ContactMap />
      <ContactWhyUs />
      <ContactFaq />
      <WashingtonBuyerFaq />
    </>
  );
}